export default __webpack_public_path__ + "static/media/patriotic.e748a545277d32042675aa7ce52216bc.png";